import { useRecoilState } from "recoil";
import { expandAllFunctionsTriggerAtom, expandedFunctionsAtom } from "../atoms/atom";

export function useExpand() {
  const [expandedFunctions, setExpandedFunctions] = useRecoilState(expandedFunctionsAtom);
  const [expandAllTrigger, setExpandAllTrigger] = useRecoilState(expandAllFunctionsTriggerAtom);
  
  return { expandedFunctions, setExpandedFunctions, expandAllTrigger, setExpandAllTrigger } as const;
}